// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from 'react-query'

import { updateTemplate } from '@/services/templates'
import { Template } from '@/services/tcc/configurator'
import { queryKey as getTemplateQueryKey } from './useGetTemplate'
import { queryKey as getTemplatesQueryKey } from './useGetTemplates'

export const useUpdateTemplate = (): UseMutationResult<
  void,
  Error,
  Template
> => {
  const queryClient = useQueryClient()

  return useMutation((template) => updateTemplate(template), {
    onSuccess: async (_, template) => {
      await Promise.all([
        queryClient.invalidateQueries(getTemplateQueryKey(template.id)),
        queryClient.invalidateQueries(getTemplatesQueryKey),
      ])
    },
  })
}
